import { useState } from 'preact/hooks'
import { type ErrorMessages, errorMessage } from './client'

/** Runs a user action, tracking its pending state and showing its error message. */
export function useAction(messages?: ErrorMessages) {
  const [error, setError] = useState<string>()
  const [pending, setPending] = useState(false)

  const run = async (action: () => Promise<void>) => {
    setPending(true)
    setError(undefined)
    try {
      await action()
    } catch (e) {
      setError(errorMessage(e, messages))
    } finally {
      setPending(false)
    }
  }

  return { error, pending, run }
}
